const meta = {
  features: 'Features overview',
  examples: 'Examples',
};

export default meta;
